
/**
 * paypal.me account that receives the donations. ⚠️ CHANGE THIS before
 * launch — until then every Donate link is a placeholder.
 */
export const PAYPAL_ME_USER = "pertbrins";